import { combineReducers } from 'redux';

import environment, * as fromEnvironment from './envReducer';
import spinner from './spinnerReducer';
import progress from './progressReducer';
import error from './errorReducer';
import messages from './messagesReducer';
import modals, * as fromModals from './modalReducer';
import sessionDataReducer from './sessionDataReducer';
import userPermissions from './userPermissionsReducer';
export default combineReducers({
    environment,
    error,
    messages,
    modals,
    spinner,
    progress,
    sessionDataReducer,
    userPermissions
});

// Modals selectors

export const isLeaveModalShown = state => fromModals.isLeaveModalShown(state.modals);

// Environment selectors

export const getIsForAdminOrOperations = state => fromEnvironment.getIsForAdminOrOperations(state.environment);
export const getIsState = state => fromEnvironment.getIsState(state.environment);
export const getTicketEnabled = state => fromEnvironment.getTicketEnabled(state.environment);
export const getStateCode = state => fromEnvironment.getStateCode(state.environment);
export const getLanguage = state => fromEnvironment.getLanguage(state.environment);
export const getServerDate = state => fromEnvironment.getServerDate(state.environment);
export const getPhoneNumber = state => fromEnvironment.getPhoneNumber(state.environment);